export default __webpack_public_path__ + "img/pazflor.ae54766a.jpg";